/* eslint-disable import/no-cycle */

import angular from 'angular';
import { Workbox } from 'workbox-window';
import { RootScope } from '../../app.config';
import { InterfaceService } from '../interface/interface.service';

/* @ngInject */
export class ServiceWorker {
  private interfaceService: InterfaceService;

  private $rootScope: RootScope;

  private serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

  constructor(
    interfaceService: InterfaceService,
    $rootScope: RootScope,
  ) {
    'ngInject';

    this.interfaceService = interfaceService;
    this.$rootScope = $rootScope;

    /**
     * If the service worker receives a new notifiaction via a push service,
     * tell the notification service to receive latest notification to also
     * show in the app
     */
    try {
      const channel = new BroadcastChannel('notification-channel');
      channel.addEventListener('message', () => this.$rootScope.$broadcast('pushNotification'));
    } catch (e) {
      console.error(`Cannot initialize broadcast channel for push notifications: ${e}`);
    }

    // if ('serviceWorker' in navigator) {
    //   window.addEventListener('load', () => {
    //     navigator.serviceWorker.register('/sw.js')
    //       .then((registration) => {
    //         console.log('ServiceWorker registration successful with scope: ', registration.scope);
    //       })
    //       .catch((err) => {
    //         console.error('ServiceWorker registration failed: ', err);
    //       });
    //   });

    //   // Check for updates in cache to display the update banner
    //   navigator.serviceWorker.addEventListener('message', async (event) => {
    //     if (event.data.meta === 'workbox-broadcast-update') {
    //       const {
    //         cacheName,
    //       } = event.data.payload;

    //       switch (cacheName) {
    //         case 'mainBundle':
    //         case 'htmlCache':
    //         case 'imageCache':
    //           interfaceService.showUpdateBanner();
    //           break;
    //         default:
    //           break;
    //       }
    //     }
    //   });
    // }
  }

  public initWorkbox = async (): Promise<void> => {
    try {
      if ('serviceWorker' in navigator) {
        console.info('Loading Service Worker with Workbox');
        const wb = new Workbox('/sw.js');
        await wb.register()
          .then((registration) => {
            if (registration) this.serviceWorkerRegistration = registration;
          });

        console.info('Loading completed');

        wb.addEventListener('installed', (event) => {
          if (event.isUpdate) {
            this.interfaceService.showUpdateBanner();
          }
        });
      }
    } catch (e) {
      console.error('error while initializing workbox', e);
      // return Promise.resolve();
    }
  };

  /**
   * Returns a promise with a current ServiceWorker registration
   */
  // public getRegistration = (): Promise<ServiceWorkerRegistration | undefined> => navigator
  //   .serviceWorker.getRegistration();

  public getRegistration = async (): Promise<ServiceWorkerRegistration | undefined> => this
    .serviceWorkerRegistration || undefined;
}

export default angular.module('serviceWorker', [])
  .service('serviceWorker', ServiceWorker)
  .name;
